import { queryString, clearEmptyParams, getGetParams } from '@/utils/filterUtils'

export const useHandlers = (params, isMore, fetcher) => {
    const onPageChange = (data) => {
        isMore.value = data.type === 'load-more'
        params.value.page = data.page
        fetcher()
    }

    const onUpdateParams = data => {
        params.value = { ...params.value, ...data }
        // queryString(clearEmptyParams(params.value))
    }

    const onFilterChange = (data) => {
        params.value.page = 1
        params.value = { ...params.value, ...data }
        setGetParams()

        fetcher()
    }

    const setGetParams = () => {
        queryString(clearEmptyParams(params.value))
    }

    const setInitParams = () => {
        params.value = { ...params.value, ...getGetParams() }
    }

    return {
        onPageChange,
        onUpdateParams,
        onFilterChange,
        setGetParams,
        setInitParams
    }
}
